import { render, staticRenderFns } from "./speltfocblem.vue?vue&type=template&id=3a766d4a&scoped=true&"
import script from "./speltfocblem.vue?vue&type=script&lang=js&"
export * from "./speltfocblem.vue?vue&type=script&lang=js&"
import style0 from "./speltfocblem.vue?vue&type=style&index=0&id=3a766d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a766d4a",
  null
  
)

export default component.exports